import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_UPDATE_INVOICE } from "../../action-types/actions";

export const updateClaimInvoice = createAsyncThunk(
  ACTIONS_UPDATE_INVOICE.updateInvoice,
  async ({ claimId, approved_amount, patient_share }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.put(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claimsinvoice.replace(
          "{claimId}",
          claimId,
        )}`,
        {
          approved_amount,
          patient_share,
        },
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Invoice updated successfully");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to update invoice");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Update claim invoice error:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while updating invoice";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
